export class UpdateCouponSession {
  public couponsession: string;
  public moneySpent: string;
}
